import { gql } from '@/__generated__';

export const RETRY_DGA_REPORTS = gql(`#graphql
  mutation RetryDGAReports($input: TriggerRetryReportsInput!) {
    triggerRetryReports(input: $input) {
      device {
        id
      }
    }
  }
`);

